import {
  FIFTEEN_MINUTES,
  ONE_MINUTE
} from './constants'

import { SwathManager } from './SwathManager';
import { Util } from './Util';

export class SwathTimeController {

  constructor(
    widget,
    swathManager,
    skipEmpty = false,
    fadeEnable = false,
    fadeDelay = FIFTEEN_MINUTES,
    fadeTime = ONE_MINUTE,
    leadLagTime = 3 * ONE_MINUTE){

    this.widget = widget;

    this.swathManager = swathManager;

    this.fadeEnable = fadeEnable;

    this.fadeTime = fadeTime;
    this.fadeDelay = fadeDelay;
    this.leadLagTime = leadLagTime;
    this.skipEmpty = skipEmpty;

    if(this.fadeEnable){
      this.defaultAlpha = SwathManager.defaultAlphaFunction;
    } else {
      this.defaultAlpha = function(v){return 1;};
    }

    widget.addTickHandler(this.tickHandler.bind(this));

  }

  tickHandler(simTime, lastSimTime){

    if(!this.swathManager.database){
      return;
    }

    // Jump to new swaths
    if(this.skipEmpty && !this.inSwath(simTime.getTime())) {

      let nextSwath = this.getNextSwath(simTime.getTime());
      if(!nextSwath) nextSwath = this.replay();
      this.swathManager.load(nextSwath, this.defaultAlpha);

      // TODO setting input, this should really be done with a return
      simTime.setTime(Util.ms2us(nextSwath.startTime) - this.leadLagTime);

    }

    // Add new swaths

    let newSwaths = this.swathManager.database.filter(element => {
      return Util.ms2us(element.startTime) - this.leadLagTime > lastSimTime.getTime()
        && Util.ms2us(element.startTime) - this.leadLagTime <= simTime.getTime();
    });
    newSwaths.forEach(element => {
      if(this.newSwathCallback){
        this.newSwathCallback(element);
      }
      this.swathManager.load(element, this.defaultAlpha);

    });


    for (const filename in this.swathManager.clouds) {

      let swath = this.swathManager.clouds[filename];

      // Delete old swaths
      if (simTime.getTime() > Util.ms2us(swath.metadata.endTime) + this.fadeDelay) {
        this.swathManager.delete(filename);
        continue;
      }

      // Fade swaths
      if(this.fadeEnable) swath.fade(simTime.getTime(), this.fadeTime, this.fadeDelay);

    };

  }

  inSwath(simTime){

    let inSwath = false;
    for (const [key, swath] of Object.entries(this.swathManager.clouds)) {
      let endTime = Util.ms2us(swath.metadata.endTime);
      if (endTime + this.leadLagTime > simTime) {
        inSwath = true;
        break;
      }
    };
    return inSwath;

  }
  
  getNextSwath(simTime){
    return this.swathManager.database.find(element => {
      return Util.ms2us(element.startTime) > simTime;
    });
  }

  replay(){

      console.log('Replay');
  
      this.swathManager.clear();
      let nextSwath = this.swathManager.database[0];
  
      this.widget.lastSimTime.setTime(Util.ms2us(nextSwath.startTime) - 2 * this.leadLagTime);          
  
      return nextSwath;
  
    }
  
}